export const SUPPORT_LINK = 'https://www.chegg.com/contactus/easybibsupport'
